/**
 * Video Fallback Module
 */
( function ( window, document ) {

    var VideoFallback = {

        /**
         * Initialize the Video Fallback module
         */
        init: function () {
            window.addEventListener( 'load', this.maybeReplaceYoutubeIframes.bind( this ) );
        },

        /**
         * Return a promise if a resource can be accessed as an image.
         *
         * @param {string} URL The URL of the image resource.
         * @returns {Promise}
         */
        testImage: function ( URL ) {
            return new Promise( function ( resolve, reject ) {
                var tester = new Image();
                tester.onload = function () { resolve(); };
                tester.onerror = function () { reject(); };
                tester.src = URL;
            });
        },

        /**
         * Checks if YouTube is accessible and if not, replaces the iframe with either a fallback URL or an MP4 video.
         *
         * @returns {void}
         */
        maybeReplaceYoutubeIframes: async function () {
            var allFrames = document.querySelectorAll( "iframe[data-fallback-url]" );

            // If no iframes on the page, bail.
            if ( !allFrames.length || !window.Intl ) {
                return;
            }

            try {
                // Test if YouTube's favicon is accessible.
                await this.testImage( "https://www.youtube.com/favicon.ico" );
            } catch ( error ) {
                // If YouTube is not accessible, try the fallback URL.
                allFrames.forEach( function ( iframe ) {
                    var fallbackUrl = iframe.getAttribute( "data-fallback-url" );
                    if ( fallbackUrl ) {
                        iframe.src = fallbackUrl;
                    } else {
                        var fallbackVideo = document.getElementById( 'fallback-video' );
                        if ( fallbackVideo ) {
                            iframe.style.display = 'none';
                            fallbackVideo.style.display = 'block';
                        }
                    }
                });
            }

            // Fallback for when the onerror does not fire (e.g., content-blocked but the iframe still loads)
            setTimeout( function () {
                allFrames.forEach( function ( iframe ) {
                    var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    if ( iframeDoc.body.innerHTML.length === 0 ) {
                        var fallbackUrl = iframe.getAttribute( "data-fallback-url" );
                        if ( fallbackUrl ) {
                            iframe.src = fallbackUrl;
                        } else {
                            var fallbackVideo = document.getElementById( 'fallback-video' );
                            if ( fallbackVideo ) {
                                iframe.style.display = 'none';
                                fallbackVideo.style.display = 'block';
                            }
                        }
                    }
                });
            }, 3000 );
        }
    };

    // Initialize the Video Fallback module
    VideoFallback.init();

}( window, document ) );
